import React, { useEffect, useRef } from 'react';

const VoiceWaveform = ({ stream }) => {
    const canvasRef = useRef(null);
    const animationRef = useRef(null);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const dataArrayRef = useRef(null);

    useEffect(() => {
        if (!stream) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        // Init Audio Context
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        audioContextRef.current = audioCtx;

        const analyser = audioCtx.createAnalyser();
        analyser.fftSize = 256;
        analyserRef.current = analyser;

        const source = audioCtx.createMediaStreamSource(stream);
        source.connect(analyser);

        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        dataArrayRef.current = dataArray;

        const draw = () => {
            const width = canvas.width;
            const height = canvas.height;

            animationRef.current = requestAnimationFrame(draw);
            analyser.getByteFrequencyData(dataArray);

            ctx.clearRect(0, 0, width, height);

            const barWidth = (width / bufferLength) * 2.5;
            let barHeight;
            let x = 0;

            for (let i = 0; i < bufferLength; i++) {
                barHeight = dataArray[i] / 2; // Scale down

                const gradient = ctx.createLinearGradient(0, height, 0, height - barHeight);
                gradient.addColorStop(0, '#3182ce');
                gradient.addColorStop(1, '#63b3ed');

                ctx.fillStyle = gradient;

                // Rounded bars logic is complex in pure canvas, sticking to rects for perf
                // But let's center them vertically for a "waveform" look
                // const y = (height - barHeight) / 2; 
                // Actually sticking to bottom alignment feels more like a voice recorder

                // Let's do a symmetric wave from center
                const y = (height - barHeight) / 2;

                ctx.fillRect(x, y, barWidth, barHeight);

                // Draw mirror for symmetry ? No, just center line looks cool
                // ctx.fillRect(x, height/2 + 2, barWidth, barHeight/2); 

                x += barWidth + 1;
            }
        };

        draw();

        return () => {
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
            if (audioContextRef.current) audioContextRef.current.close();
        };
    }, [stream]);

    return (
        <canvas
            ref={canvasRef}
            width={200}
            height={40}
            className="voice-waveform"
        />
    );
};

export default VoiceWaveform;
